// extracted by mini-css-extract-plugin
export default {"errorPageWrap":"error_errorPageWrap__kaCaW","errorPageContent":"error_errorPageContent__45juw"};